import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const approveRegistration = async (linkId, regId) => {
  const response = await axios.post(
    routes.inviteflowApproveRegistration(linkId, regId),
    {},
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default approveRegistration;
